export const CATEGORY_IDS = {
  CONTENT_CATEGORIES: 'content_categories',
} as const;
